module.exports = __webpack_public_path__ + "static/media/login.fbff567b.jpg";